import { Router } from "@frui.ts/screens";
import { computed } from "mobx";
import download from "downloadjs";
import * as Sentry from "@sentry/react";
import BankExportRepository from "repositories/bankExportRepository";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import OptionsService from "services/optionsService";
import SecurityService from "services/securityService";
import BankExportListViewModel from "../bankExportListViewModel";
import { getBankExportFilename } from "../utils";
import InternalTransferDetailViewModel from "./internalTransferDetailViewModel";
import parseFileNameFromAxiosResponse from "utils/parseFileNameFromAxiosResponse";
import type InternalTransferExportResponse from "entities/internalTransferExportResponse";

const navigationName = "internal-transfers";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [InternalTransferDetailViewModel],
})
export default class InternalTransfersListViewModel extends BankExportListViewModel<InternalTransferExportResponse> {
  @computed
  get name() {
    return this.translate("internalTransfers");
  }

  constructor(
    public detailViewModelFactory: ReturnType<typeof InternalTransferDetailViewModel.Factory>,
    public repository: BankExportRepository,
    public securityService: SecurityService,
    public eventBus: EventBus,
    public localizationService: LocalizationService,
    public notificationService: NotificationService,
    public optionsService: OptionsService
  ) {
    super(repository, securityService, eventBus, localizationService, notificationService, optionsService);
    this.navigationName = navigationName;
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.allInternalTransfers({ offset, limit }, this.appliedFilter);
  }

  async download(item: InternalTransferExportResponse) {
    try {
      if (this.allowToDownload) {
        this.fileResponse = await this.repository.getInternalTransferReport(item.id);
        download(
          this.fileResponse.data,
          parseFileNameFromAxiosResponse(this.fileResponse, getBankExportFilename(item)),
          "application/zip"
        );
      }
    } catch (exc) {
      Sentry.captureException(exc);
    }
  }
}
